// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__3Vbgr","answer--dot":"Answer_answer--dot__3BxiW","answer--text":"Answer_answer--text__2m6zP"};